import React, { useEffect, useState } from 'react';
import style from './ClientFormData.module.css';
import axios from 'axios';
import DashboardNavbar from '../../utilities/DashboardNavbar/DashboardNavbar';
import { NavLink } from 'react-router-dom';
import EditPeopleForm from './EditPeopleForm/EditPeopleForm';
import Modal from './People/ModelPop/Modal';
import {data} from '../../../evn/evn.js'
import SideNav from '../../utilities/SideNavBar/SideNav.jsx';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { Button, CircularProgress, Tooltip } from "@mui/material";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';




const ClientFormData = () => {
  const openModal = () => setIsModalOpen(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const [clientData, setClientData] = useState([]);
  const [editingClient, setEditingClient] = useState(null);
  const [downloadingCaseId, setDownloadingCaseId] = useState(null);

  const ip = data.evn;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1150);

  const [currentPage, setCurrentPage] = useState(1);
const [clientPerPage, setClientPerPage] = useState(6);

const indexOfLastClient = currentPage * clientPerPage;
const indexOfFirstClient = indexOfLastClient - clientPerPage;
const currentClient = clientData.slice(indexOfFirstClient, indexOfLastClient);

// Pagination handlers
const handleNextPage = () => {
  setCurrentPage(currentPage + 1);
};

const handlePreviousPage = () => {
  setCurrentPage(currentPage - 1);
};


  useEffect(() => {
    // Function to update the isMobile state based on window width
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1150);
    };
    // Call handleResize initially to set the correct state when the component mounts
    handleResize();
    // Set up the event listener
    window.addEventListener("resize", handleResize);
    // Clean up the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchClientData = async () => {
    try {
      const response = await axios.get(`${ip}/dashboard/clientform/edit`, {
        headers: {
          'x-auth-token': localStorage.getItem('token'), // Get the token from localStorage or your authentication mechanism
        },
      });

      setClientData(response.data); // Set the client data received from the backend
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // Fetch client data from the backend when the component mounts
    fetchClientData();
  }, []);

  const handleDeleteClick = async (clientId) => {
    if (window.confirm('Are you sure you want to delete this client?')) {
      try {
        await axios.delete(`${ip}/clientformdata/${clientId}`, {
          headers: { 'x-auth-token': localStorage.getItem('token') },
        });
        fetchClientData(); // Refetch the clients to update the UI
      } catch (error) {
        console.error(error);
      }
    }
    // console.log('Delete button clicked with clientId:', clientId); // Add this line for debugging
  };
   
  const handleEditClick = (clientItem) => {
    setEditingClient(clientItem.id);
    openModal();
  };
  const handleCancelClick = () => {
    setEditingClient(null);
    closeModal();
  };
  const handleDownloadClick = async (clientId) => {
    setDownloadingCaseId(clientId); // Start showing the CircularProgress

    try {
      // Make an HTTP GET request to download the PDF for the specified client ID
      const response = await axios.get(`${ip}/clientformdata/download-pdf/${clientId}`, {
        responseType: 'blob', // Set responseType to 'blob' to receive binary data
        headers: {
          'x-auth-token': localStorage.getItem('token'),
        },
      });
  
      // Create a URL for the blob data
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
  
      // Create an anchor element and trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = `Client_${clientId}.pdf`;
      a.click();
      setDownloadingCaseId(null);

    } catch (error) {
      setDownloadingCaseId(null);

      console.error(error);
    }
  };

  return (
    <>
      {isMobile ? ( <SideNav /> ) : ( <DashboardNavbar />)}
      <div className={style.container}>
        <h2 className={style.heading}>PEOPLE STACK</h2>
        <div className={style.scrolable}>
        <table className={style.table}>
          <thead className={style.tableHead}>
            <tr>
              <th className={style.titleColumn}>Fullname</th>
              <th className={style.titleColumn2}>Email</th>
              <th>Mobile No</th>
              <th>Assign Alerts</th>
              <th>Schedule Appointment</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className={style.tableBody}>
            {currentClient.map((clientItem, index) => (
              <tr className={style.DataColume} key={index}>
                <td className={style.titleColumn}>{clientItem.firstName + ' ' + clientItem.lastName}</td>
                <td className={style.titleColumn2}>{clientItem.email}</td>
                <td className={style.td}>{clientItem.mobileNo}</td>
                <td className={style.td}>{clientItem.assignAlerts}</td>
                <td className={style.td}>{clientItem.assignAppointments}</td>
                <td>

                  <Tooltip title="Edit" disableInteractive>
                    <button className={style.btn} onClick={() => handleEditClick(clientItem)}>
                  <BorderColorIcon />
                    </button>
                  </Tooltip>
                  <Tooltip title="Delete" disableInteractive>
                    <button
                      className={style.btn}
                      type="button"
                      onClick={() => handleDeleteClick(clientItem.id)}
                    >
                  <DeleteIcon />
                    </button>
                  </Tooltip>
                  <Tooltip title="Download PDF" disableInteractive>
                    <button
                    className={style.btn}
                    type="button"
                    onClick={() => handleDownloadClick(clientItem.id)}
                    >
                  <DownloadForOfflineIcon /> 
                    {downloadingCaseId === clientItem.id && <CircularProgress size="1.5rem" color="inherit" />} 

                    </button>
                  </Tooltip>
                </td>
              </tr>
                
            ))}
          </tbody>
          <Modal isOpen={isModalOpen} onClose={closeModal}>
          {/* Pass the selected case data to EditCaseForm */}
          {editingClient && (
            <EditPeopleForm
              clientData={clientData.find((clientItem) => clientItem.id === editingClient)}
              onCancel={handleCancelClick}
              onClose={handleCancelClick}
            />
          )}
        </Modal>

         {/* Pagination Controls */}
         <div className={style.paginationContainer}>
          
          <Button onClick={handlePreviousPage} disabled={currentPage === 1} className={style.previousButton}>
          
            <KeyboardDoubleArrowLeftIcon style={{color:'var(--color-fifth)'}}/>
            <span className={style.prev}>{currentPage === 1 ? "Prev 0" : `Prev ${currentPage - 1}`}</span>
            
          </Button>
    
          <span className={style.currentPageIndicator}>
            {currentPage}
          </span>
    
          <Button onClick={handleNextPage} disabled={currentPage >= Math.ceil(clientData.length / clientPerPage)} className={style.nextButton}>
          
            <span className={style.next}>Next {currentPage + 1}</span>
            <KeyboardDoubleArrowRightIcon style={{color:'var(--color-fifth)'}}/>
            
          </Button>
        </div>
        </table>
        </div>
      </div>
      
    </>
    
  );
};

export default ClientFormData;
